import { useState } from "react";
import toast from "react-hot-toast";
import useGet from "../read/useGet";
import usePut from "../put/usePut";
import useUpload from "../useUpload";

export const usePettyCashForm = ({ companyEmployeeId, onSuccess, onClose, reset }) => {
  const [mediaId, setMediaId] = useState(null);
  const [mediaPath, setMediaPath] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  // 1. Fetch expense types listing
  const { list: expenseTypes } = useGet({
    url: "petty-cash/get_expenses_type_listing",
    initialData: {},
  });

  // 2. Receipt upload mutation
  const uploadReceipt = useUpload({
    url: "/uploadImage",
    paramName: "thumbnail[]",
    onSuccess: (res) => {
      setIsUploading(false);
      if (res?.data?.data?.[0]) {
        const { image_id, image_url } = res.data.data[0];
        setMediaId(image_id);
        setMediaPath(image_url);
        toast.success("Receipt uploaded successfully");
      } else {
        toast.error("Failed to process uploaded receipt");
      }
    },
    onError: (err) => {
      setIsUploading(false);
      toast.error("Failed to upload receipt");
    },
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setIsUploading(true);
    uploadReceipt.mutate({ file });
  };

  const removeReceipt = (fileInputRef) => {
    setMediaId(null);
    setMediaPath(null);
    if (fileInputRef?.current) {
      fileInputRef.current.value = "";
    }
  };

  // 3. Submit transaction mutation
  const { handleAuth: submitTransactionMutation } = usePut({
    url: "petty-cash/create_transaction",
    refreshUrl: ["petty-cash/transaction_listing", "petty-cash/statistics"],
    onSuccess: (res) => {
      toast.success(res?.data?.message || "Transaction added successfully");
      onSuccess?.();
      onClose();
      reset();
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Failed to add transaction");
    },
  });

  const { mutate: submitTransaction, isLoading: isSaving } = submitTransactionMutation;

  const handleSave = (data) => {
    const listOptions = expenseTypes.data?.data || [];
    const selectedId = data.expenses_type_id;

    const matchedOption = listOptions.find((opt) => String(opt.id) === String(selectedId));
    const finalId = matchedOption ? matchedOption.id : "";
    const finalName = matchedOption ? matchedOption.name : (selectedId || "");

    const formData = {
      expenses_date: data.expenses_date ? (data.expenses_date instanceof Date ? data.expenses_date.toISOString().split('T')[0] : data.expenses_date) : "",
      particulars: data.particulars,
      expenses_type_id: finalId,
      expenses_type_name: finalName,
      amount: data.amount,
      transaction_type: data.transaction_type,
      company_employee_id: companyEmployeeId || "",
      invoice_no: data.invoice_no || "",
      chq_no: data.chq_no || "",
      chq_date: data.chq_date ? (data.chq_date instanceof Date ? data.chq_date.toISOString().split('T')[0] : data.chq_date) : "",
      additional_remarks: data.additional_remarks || "",
      media_id: mediaId || "",
    };
    submitTransaction(formData);
  };

  return {
    expenseTypes,
    mediaId,
    mediaPath,
    isUploading,
    isSaving,
    handleFileChange,
    removeReceipt,
    handleSave,
  };
};
